// extracted by mini-css-extract-plugin
module.exports = {"thumb":"i_GF"};